import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import useRevealOnScroll from '../hooks/useRevealOnScroll';

// Картинки
import Video from '../assets/services/video_nabludenie.png';
import Switch from '../assets/services/switch.png';
import Terror from '../assets/services/terror.png';
import Sts from '../assets/services/sts.png';
import Forensic from '../assets/services/forensic.png';
import Drone from '../assets/services/drone.jpg';
import Antidrone from '../assets/services/antidrone.jpg';
import Mesh from '../assets/services/mesh.jpeg';
import Radio from '../assets/services/motorola.jpg';

const images = [Video, Switch, Radio, Terror, Forensic, Mesh, Drone, Antidrone, Sts];

// Иконки-бейджи услуг (поверх фото)
const icons = [
  // Видеонаблюдение и видеоаналитика
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="3" y="6" width="13" height="12" rx="2" stroke="currentColor" strokeWidth="1.6" /><path d="M16 10.5l5-3v9l-5-3" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /><circle cx="9.5" cy="12" r="2.3" stroke="currentColor" strokeWidth="1.6" /></svg>,
  // Локально вычислительные системы
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="4" rx="1" stroke="currentColor" strokeWidth="1.6" /><rect x="4" y="10" width="16" height="4" rx="1" stroke="currentColor" strokeWidth="1.6" /><rect x="4" y="16" width="16" height="4" rx="1" stroke="currentColor" strokeWidth="1.6" /><circle cx="7.2" cy="6" r="0.6" fill="currentColor" /><circle cx="7.2" cy="12" r="0.6" fill="currentColor" /><circle cx="7.2" cy="18" r="0.6" fill="currentColor" /></svg>,
  // Радиосвязь Motorola TETRA
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.5 5.5a5 5 0 007 0M6 8a8 8 0 0012 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><rect x="9.5" y="10" width="5" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.6" /></svg>,
  // Антитеррористическая защита
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v6c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /><path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  // Цифровая криминалистика
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="10.5" cy="10.5" r="6" stroke="currentColor" strokeWidth="1.6" /><path d="M15 15l5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><path d="M10.5 7.5v3l2 1.3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  // Система радиосвязи Mesh
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="5" cy="6" r="2" stroke="currentColor" strokeWidth="1.6" /><circle cx="19" cy="6" r="2" stroke="currentColor" strokeWidth="1.6" /><circle cx="12" cy="13" r="2" stroke="currentColor" strokeWidth="1.6" /><circle cx="6" cy="19" r="2" stroke="currentColor" strokeWidth="1.6" /><circle cx="18" cy="19" r="2" stroke="currentColor" strokeWidth="1.6" /><path d="M6.6 7.4L10.6 11.6M17.4 7.4L13.4 11.6M10.6 14.4L7.4 17.6M13.4 14.4L16.6 17.6" stroke="currentColor" strokeWidth="1.2" /></svg>,
  // Дрон-системы автономного освещения
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="2.4" stroke="currentColor" strokeWidth="1.6" /><path d="M12 9.6L6 5M12 9.6l6-4.6M12 14.4L6 19M12 14.4l6 4.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><circle cx="5" cy="4.4" r="1.6" stroke="currentColor" strokeWidth="1.3" /><circle cx="19" cy="4.4" r="1.6" stroke="currentColor" strokeWidth="1.3" /><circle cx="5" cy="19.6" r="1.6" stroke="currentColor" strokeWidth="1.3" /><circle cx="19" cy="19.6" r="1.6" stroke="currentColor" strokeWidth="1.3" /></svg>,
  // Анти-БПЛА
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v6c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /><path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  // СТС
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="7" y="7" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="1.6" /><path d="M9.5 7V4.5M14.5 7V4.5M9.5 19.5V17M14.5 19.5V17M7 9.5H4.5M7 14.5H4.5M17 9.5h2.5M17 14.5h2.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
];

const links = [
  "/video",
  "/localsystems",
  "/radio",
  "/antiterror",
  "/digitalforensics",
  "/mesh",
  "/drones",
  "/antidrone",
  "/sts",
];

// Лёгкое чередование оттенков свечения панелей — cyan / blue / lime
const tints = ['0,194,255', '0,112,210', '163,230,53'];

function ServiceRow({ idx, service, reversed, tint, onClick, moreLabel }) {
  const [revealRef, isVisible] = useRevealOnScroll(0.1);

  const handleSpotlight = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty('--x', `${((e.clientX - rect.left) / rect.width) * 100}%`);
    e.currentTarget.style.setProperty('--y', `${((e.clientY - rect.top) / rect.height) * 100}%`);
  };

  return (
    <div
      ref={revealRef}
      onClick={onClick}
      className={`reveal group flex flex-col md:items-center gap-8 md:gap-16 py-14 sm:py-16 cursor-pointer ${
        reversed ? 'md:flex-row-reverse' : 'md:flex-row'
      } ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="flex-1 min-w-0">
        <span
          className="font-display font-extrabold text-white/[0.04] block leading-none select-none text-[96px] sm:text-[120px] -mb-8 sm:-mb-10"
          aria-hidden="true"
        >
          {String(idx + 1).padStart(2, '0')}
        </span>
        <h3 className="font-display text-2xl sm:text-3xl font-bold text-white mb-4 relative">
          {service.title}
        </h3>
        <p className="text-white/60 leading-relaxed max-w-lg mb-5 relative">
          {service.description}
        </p>
        <span className="font-display inline-flex items-center gap-1.5 text-sm font-semibold text-cyan-300 group-hover:text-white transition relative">
          {moreLabel} →
        </span>
      </div>

      <div
        onMouseMove={handleSpotlight}
        className="spotlight glass-card flex-none w-full md:w-[380px] h-[220px] sm:h-[260px] rounded-3xl relative overflow-hidden transition-colors duration-300 group-hover:border-cyan-400/40"
      >
        <img
          src={service.image}
          alt={service.title}
          className="absolute inset-0 w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-500"
        />
        <div
          className="absolute inset-0"
          style={{
            background: `radial-gradient(circle at ${reversed ? '70%' : '30%'} 25%, rgba(${tint},0.35), transparent 60%), linear-gradient(180deg, rgba(5,8,16,0.15), rgba(5,8,16,0.65))`,
          }}
        />
        <div className="absolute z-10 top-5 left-5 w-11 h-11 rounded-xl bg-black/40 backdrop-blur-sm border border-white/10 flex items-center justify-center text-cyan-300">
          {service.icon}
        </div>
      </div>
    </div>
  );
}

export default function ServicesSection() {
  const { t } = useTranslation('services');
  const navigate = useNavigate();
  const [titleRef, titleVisible] = useRevealOnScroll(0.3);

  const services = t('items', { returnObjects: true }).map((item, idx) => ({
    ...item,
    link: links[idx],
    icon: icons[idx],
    image: images[idx],
  }));

  return (
    <section
      id="services"
      className="scroll-mt-28 lg:scroll-mt-32 w-full py-16 relative overflow-hidden"
    >
      <div className="grid-bg" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={titleRef} className={`reveal mb-6 ${titleVisible ? 'is-visible' : ''}`}>
          <p className="font-mono text-xs tracking-[0.3em] text-white/40 mb-2">
            01&ndash;{String(services.length).padStart(2, '0')}
          </p>
          <h2 className="font-display text-4xl font-bold text-white">
            {t("section_title")}
          </h2>
          <span className={`title-accent ${titleVisible ? 'is-visible' : ''}`} />
        </div>

        <div className="divide-y divide-white/10">
          {services.map((service, idx) => (
            <ServiceRow
              key={idx}
              idx={idx}
              service={service}
              reversed={idx % 2 === 1}
              tint={tints[idx % tints.length]}
              onClick={() => navigate(service.link)}
              moreLabel={t("more")}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
